import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { AccessibilityProvider } from './contexts/AccessibilityContext';
import { ChatProvider } from './contexts/ChatContext';
import TrialEndingNotification from './components/TrialEndingNotification';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import RecipeDetailPage from './pages/RecipeDetailPage';
import CreateRecipePage from './pages/CreateRecipePage';
import EditRecipePage from './pages/EditRecipePage';
import AIGeneratorPage from './pages/AIGeneratorPage';
import ChatAssistantPage from './pages/ChatAssistantPage';
import MealPlannerPage from './pages/MealPlannerPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import SubscriptionPage from './pages/SubscriptionPage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import ManageSubscriptionPage from './pages/ManageSubscriptionPage';
import AdminDashboard from './pages/AdminDashboard';
import CopyrightPage from './pages/CopyrightPage';
import ContactPage from './pages/ContactPage';
import MessagesAdminPage from './pages/MessagesAdminPage';

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <AccessibilityProvider>
            <ChatProvider>
              <TrialEndingNotification />
            <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            
            {/* Protected Routes */}
            <Route path="/" element={<Layout><ProtectedRoute><HomePage /></ProtectedRoute></Layout>} />
            <Route path="/recipe/:id" element={<Layout><ProtectedRoute><RecipeDetailPage /></ProtectedRoute></Layout>} />
            <Route path="/create" element={<Layout><ProtectedRoute><CreateRecipePage /></ProtectedRoute></Layout>} />
            <Route path="/edit/:id" element={<Layout><ProtectedRoute><EditRecipePage /></ProtectedRoute></Layout>} />
            <Route path="/ai-generator" element={<Layout><ProtectedRoute><AIGeneratorPage /></ProtectedRoute></Layout>} />
            <Route path="/chat-assistant" element={<Layout><ProtectedRoute><ChatAssistantPage /></ProtectedRoute></Layout>} />
            <Route path="/meal-planner" element={<Layout><ProtectedRoute><MealPlannerPage /></ProtectedRoute></Layout>} />
            <Route path="/profile" element={<Layout><ProtectedRoute><ProfilePage /></ProtectedRoute></Layout>} />
            <Route path="/subscription" element={<Layout><ProtectedRoute><SubscriptionPage /></ProtectedRoute></Layout>} />
            <Route path="/subscription/success" element={<Layout><ProtectedRoute><SubscriptionSuccessPage /></ProtectedRoute></Layout>} />
            <Route path="/subscription/manage" element={<Layout><ProtectedRoute><ManageSubscriptionPage /></ProtectedRoute></Layout>} />
            <Route path="/admin" element={<Layout><ProtectedRoute><AdminDashboard /></ProtectedRoute></Layout>} />
            <Route path="/admin/messages" element={<Layout><ProtectedRoute><MessagesAdminPage /></ProtectedRoute></Layout>} />
            <Route path="/copyright" element={<Layout><CopyrightPage /></Layout>} />
            <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          </Routes>
            </ChatProvider>
          </AccessibilityProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;